import { OTPVerification } from "../../../components/otp-verification";

export default function VerifyPage() {
  return (
    <main className="relative bg-white min-h-screen overflow-hidden">
      {/* Leaf decorations */}
      <div className="bottom-20 left-0 z-0 absolute opacity-80 w-40 h-40">
        <img src="/assets/22.png" alt="" width={200} height={200} className="object-contain" />
      </div>
      <div className="right-0 bottom-0 z-0 absolute opacity-80 w-40 h-40">
        <img src="/assets/24.png" alt="" width={200} height={200} className="object-contain" />
      </div>

      <div className="mx-auto px-4 py-8 container">
        <header className="flex justify-between items-center mb-16">
          <div className="flex items-center">
            <img src="/assets/logo/logo.svg" alt="" />
            <span className="font-bold text-emerald-800 text-2xl">MedTag</span>
          </div>
          <a href="/contact" className="text-emerald-600 hover:text-emerald-700 transition-colors">
            Contact
          </a>
        </header>

        <div className="mx-auto max-w-md">
          <OTPVerification />
        </div>
      </div>
    </main>
  )
}

